import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  inject,
  DestroyRef,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogClose,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { WorkerGroup } from '../../../../models/worker-group.model';
import { WorkPlaceGroup } from '../../../../models/work-place-group.model';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { WorkerWorkPlaceGroup } from '../../../../models/worker-work-place-group.model';
import {
  UserGroupService,
  WorkerWorkplaceGroupService,
  WorkplaceGroupService,
} from '../../../../services';
import { ToastAlertService } from '@core/services';
import { ButtonComponent } from '@shared/components/button/button.component';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { TitleComponent } from '@shared/components/title/title.component';

@Component({
  selector: 'app-worker-work-place-group-modal',
  templateUrl: './worker-work-place-group-modal.component.html',
  styles: [
    `
      .container {
        background: #f5f5f5;
      }
    `,
  ],
  standalone: true,
  imports: [
    TitleComponent,
    NgClass,
    MatCardModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    NgFor,
    MatOptionModule,
    NgIf,
    ButtonComponent,
    MatDialogClose,
    MatDialogTitle,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
  ],
})
export class WorkerWorkPlaceGroupModalComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  private formBuilder = inject(FormBuilder);
  private workerGroupService = inject(UserGroupService);
  private workPlaceService = inject(WorkplaceGroupService);
  private workerWorkService = inject(WorkerWorkplaceGroupService);
  private dialogRef = inject(MatDialogRef<WorkerWorkPlaceGroupModalComponent>);
  private alertService = inject(ToastAlertService);
  private destroyRef = inject(DestroyRef);
  public operation = '';
  public workerWorkPlaceGroupForm!: FormGroup;
  groupsUser: WorkerGroup[];
  nameGroupUserSelected: string;
  dataSource: MatTableDataSource<WorkerWorkPlaceGroup>;
  groupsWork: WorkPlaceGroup[];
  private idUser = 0;
  private idWork = 0;
  displayedColumns: string[] = ['name', 'description'];
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.dataSource = new MatTableDataSource();
    this.groupsUser = [];
    this.groupsWork = [];
    this.nameGroupUserSelected = '';
  }

  ngOnInit(): void {
    this.chargueGroupUsers();
    this.chargueGroupsWork();
    this.builderForm();
  }

  private builderForm() {
    this.idUser = this.data.action.idUser;
    this.idWork = this.data.action.idGroup;
    if (this.data.action.idGroup && this.data.action.idUser) {
      this.operation = 'Modificar Asignación';
      this.workerWorkPlaceGroupForm = this.formBuilder.group({
        workerGroupId: [
          { value: this.idUser, disabled: true },
          Validators.required,
        ],
        workplaceGroupId: [this.idWork, Validators.required],
      });
    } else {
      this.operation = 'Asignar';
      this.workerWorkPlaceGroupForm = this.formBuilder.group({
        workerGroupId: ['', Validators.required],
        workplaceGroupId: ['', Validators.required],
      });
    }
  }

  private chargueGroupUsers() {
    this.workerGroupService
      .getUserGroups(this.data.businessId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          if (resp.code === 10000) {
            this.groupsUser = resp.reply;
          } else {
            this.alertService.error(resp.detail);
          }
        },
      });
  }
  get id_action() {
    return this.workerWorkPlaceGroupForm.get('workerGroupId');
  }
  private chargueGroupsWork() {
    this.workPlaceService
      .getWorkplaces(this.data.businessId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          if (resp.code === 10000) {
            this.groupsWork = resp.reply;
          } else {
            this.alertService.error(resp.detail);
          }
        },
      });
  }

  chargueDataSource(groupUsers: number) {
    this.workerGroupService
      .getUserGroup(groupUsers)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          if (resp.code === 10000) {
            this.dataSource = new MatTableDataSource(
              resp.reply.workplaceGroups
            );
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          } else {
            this.alertService.error(resp.detail);
          }
        },
      });
    if (this.idUser == 0) {
      this.chargueGroupsWorkId(groupUsers);
    } else {
      this.chargueGroupsWork();
    }
  }
  private chargueGroupsWorkId(id: number) {
    this.workerGroupService
      .getUserGroup(id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          if (resp.code === 10000) {
            this.groupsWork = resp.reply.workplaceGroupsNotAssigned;
          } else {
            this.alertService.error(resp.detail);
          }
        },
      });
  }

  submit() {
    if (this.idUser == 0) {
      this.storeWorkerWork();
    } else {
      this.updateWorkerWork();
    }
  }

  private storeWorkerWork() {
    if (this.workerWorkPlaceGroupForm.valid) {
      this.workerWorkService
        .storeWorkerWorkplaceGroup(
          this.workerWorkPlaceGroupForm.value,
          this.data.businessId
        )
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: resp => {
            if (resp.code === 10000) {
              this.dialogRef.close([true, this.id_action?.value]);
              this.alertService.sucess('Asignación Correcta');
            } else {
              this.alertService.error(resp.detail);
            }
          },
        });
    }
  }

  private updateWorkerWork() {
    if (this.workerWorkPlaceGroupForm.valid) {
      this.workerWorkService
        .updateWorkerWorkplaceGroup(
          this.idUser,
          this.idWork,
          this.workerWorkPlaceGroupForm.value,
          this.data.businessId
        )
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: resp => {
            if (resp.code === 10000) {
              this.dialogRef.close([true, this.id_action?.value]);
              this.alertService.sucess('Asignación modificada');
            } else {
              this.alertService.error(resp.detail);
            }
          },
        });
    }
  }
}
